import React from 'react';
import PropTypes from 'prop-types';

import { VpTagInput } from '../inputs';
import { useFetchTags, useCreateTag } from '../../hooks/react-query';

const ImportMediaTagInput = ({ value, tagsStateHandler }) => {
  const { data: tagData } = useFetchTags();
  const { mutate: createTag } = useCreateTag();

  const onChangeTagInput = (value) => {
    const existingTags = value.filter((val) => !val.inputValue);
    const newTags = value.filter((val) => val.inputValue);

    // handle creating new tags on the fly
    if (newTags.length) {
      createTag({
        tagName: newTags[0].inputValue
      });
    }

    // handle including existing tags
    tagsStateHandler(existingTags);
  };

  return (
    <VpTagInput
      options={tagData || []}
      value={value}
      onChange={onChangeTagInput}
      label="Choose tags to include in imported media"
      placeholder="Select your tags"
      sx={{ width: '100%' }}
    />
  );
};

ImportMediaTagInput.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),
  tagsStateHandler: PropTypes.func
};

export default ImportMediaTagInput;



// WEBPACK FOOTER //
// ./src/vp-ui/components/ImportMediaTagInput.jsx